import React, {useEffect, useRef, useState} from 'react'
import {ModeleEquipe} from "../../../../components/Models";
import {KTSVG} from "../../../../_metronic/helpers";
import {getEquipeUtilisateur} from "../../../../components/requests";
import Select from "react-select";

type EquipeModalProps = {
  selectedEquipe: number | null,
  setSelectedEquipe: (equipe: number | null) => void,
  currentPage: string,
  action?: (equipe: number | null) => void,
}

const EquipeModal = (props: EquipeModalProps) => {
  const {
    selectedEquipe,
    setSelectedEquipe,
    currentPage = false,
    action
  } = props
  const [equipes, setEquipes] = useState<ModeleEquipe[]>([])
  const [selectedTempEquipe, setSelectedTempEquipe] = useState<number | null>(null)
  const [loading, setLoading] = useState<boolean>(true)
  const [selectedFiltre, setSelectedFiltre] = useState<string>('tous')
  const refCloseButton = useRef<any>(null)

  const getListEquipes = () => {
    getEquipeUtilisateur()
      .then(res => {
        if (res?.status === 200 && res?.data !== undefined) setEquipes(res?.data)
      })
      .catch(() => console.error('Erreur'))
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    getListEquipes()
  }, []);

  return (
    <>
      <div
        className='modal fade'
        id='choixEquipeModal'
        aria-hidden='true'
        aria-labelledby='modalToggleEquipe'
        tabIndex={-1}
      >
        <div className='modal-dialog'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h5 className='modal-title' id='modalToggleEquipe'>
                {(currentPage === "creation" || currentPage === "modification") ?
                  'Merci de choisir l\'équipe en charge de cette demande' :
                  'Attribuer une nouvelle équipe à cette demande'}
              </h5>
              <div
                className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                data-bs-dismiss='modal'
                aria-label='Close'
                ref={refCloseButton}
              >
                <KTSVG
                  path='/media/icons/duotune/arrows/arr061.svg'
                  className='svg-icon svg-icon-2x'
                />
              </div>
            </div>
            <div className='modal-body'>
              {loading ? (
                <span
                  className='indicator-progress text-muted text-center'
                  style={{display: 'block'}}
                >
                  Chargement des équipes ...
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              ) : equipes.length > 0 ? (
                <>
                  <div
                    className="d-flex w-100 mb-3 p-1 bg-light rounded-3 gap-1 mb-6"
                    role="radiogroup"
                    aria-label="Filtrer les équipes par catégorie"
                  >
                    {[
                      {key: "tous", id: "Tous", label: "Tous"},
                      {key: "autos", id: "Autos", label: "Autos"},
                      {key: "indus", id: "Industrie", label: "Industrie"},
                      {key: "motos", id: "Motos", label: "Motos"},
                    ].map(({key, id, label}) => (
                      <React.Fragment key={key}>
                        <input
                          type="radio"
                          className="btn-check"
                          name="filtreEquipe"
                          id={id}
                          autoComplete="off"
                          checked={selectedFiltre === key}
                          onChange={() => setSelectedFiltre(key)}
                        />
                        <label
                          className={`btn btn-sm flex-fill fw-semibold border-0 rounded-2 py-2 ${
                            selectedFiltre === key
                              ? "bg-white text-primary shadow-sm"
                              : "text-gray-600 bg-transparent"
                          }`}
                          htmlFor={id}
                        >
                          {label}
                        </label>
                      </React.Fragment>
                    ))}
                  </div>
                  <Select
                    className='react-select-styled react-select-solid react-select-lg'
                    classNamePrefix='react-select'
                    options={
                      equipes
                        ?.map((equipe) => ({value: equipe?.id, label: equipe?.nom}))
                        ?.filter((equipe) => {
                          if (selectedFiltre === "tous") return true;
                          return equipe?.label?.toLowerCase()?.startsWith(selectedFiltre);
                        })
                    }
                    fieldName='demande_equipe'
                    value={
                      equipes
                        ?.filter((equipe) => {
                          if (selectedFiltre === "tous") return true;
                          return equipe?.nom?.toLowerCase()?.startsWith(selectedFiltre);
                        })
                        ?.filter((equipe) => (equipe?.id === (selectedTempEquipe ?? selectedEquipe)))
                        ?.map((equipe) => ({value: equipe?.id, label: equipe?.nom}))
                    }
                    onChange={(e) => setSelectedTempEquipe(e?.value || null)}
                    placeholder='Sélectionner une équipe'
                  />
                </>
              ) : (
                <span>Aucune équipe trouvée</span>
              )}
            </div>
            <div className='modal-footer'>
              <button
                type='button'
                className='btn btn-light-secondary'
                data-bs-dismiss='modal'
                onClick={() => setSelectedEquipe(null)}
              >
                Annuler
              </button>
              <button
                type='button'
                className='btn btn-light-primary'
                data-bs-dismiss='modal'
                onClick={() => {
                  setSelectedEquipe(selectedTempEquipe)
                  setTimeout(() => {
                    if (action && currentPage === "creation") action(selectedTempEquipe)
                  }, 500);

                }}
              >
                Valider l'équipe
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default EquipeModal;